import { config } from './config';
import { default as useClientDefault } from './use-client';

export type { _ReturnType } from './use-client';
export { config };
export const useClient = Object.assign(useClientDefault, {
  ...config,
});
